import MDTypography from "components/MDTypography";

import { useCustomerNotifications } from "context/CustomerNotificationsContext";
import { loadingColumn, loadingRow } from "components/LoadingItemsList";

export default function data() {
  const {
    customersNotifications,
    setEditCustomerNotification,
    deleteCustomerNotification,
    loading,
  } = useCustomerNotifications();

  const handlePressEdit = (customer) => {
    setEditCustomerNotification(customer);
  };

  const handlePressDelete = (id) => {
    deleteCustomerNotification(id);
  };

  const customersNotificationsColumn = [
    { Header: "Notificar em", accessor: "notify_at", width: "45%", align: "left" },
    { Header: "Notas", accessor: "note", align: "center" },
    { Header: "status", accessor: "status", align: "center" },
    { Header: "notificado", accessor: "notified", align: "center" },
    { Header: "action", accessor: "action", align: "center" },
    { Header: "delete", accessor: "delete", align: "center" },
  ];

  const customersNotificationsRows = Object.values(customersNotifications).map(
    (customersNotification) => ({
      notify_at: (
        <MDTypography display="block" variant="button" fontWeight="medium">
          {customersNotification.notify_at}
        </MDTypography>
      ),
      note: (
        <MDTypography variant="button">
          {/* {customersNotification?.note?.length === 0 ? customersNotification.note : "NÃO CADASTRADO"} */}
          {customersNotification.note}
        </MDTypography>
      ),
      status: <MDTypography variant="button">{customersNotification.status}</MDTypography>,
      notified: <MDTypography variant="button">{customersNotification.notified}</MDTypography>,
      action: (
        <MDTypography
          display="block"
          variant="button"
          fontWeight="medium"
          onClick={() => handlePressEdit(customersNotification)} // Passing the id to the handler
          style={{ cursor: "pointer", color: "blue" }}
        >
          Edit
        </MDTypography>
      ),
      delete: (
        <MDTypography
          display="block"
          variant="button"
          fontWeight="medium"
          onClick={() => handlePressDelete(customersNotification.id)} // Passing the id to the handler
          style={{ cursor: "pointer", color: "#eb4034" }}
        >
          Delete
        </MDTypography>
      ),
    })
  );

  return {
    columns: loading ? loadingColumn : customersNotificationsColumn,
    rows: loading ? loadingRow : customersNotificationsRows,
  };
}
